export const LIQUIDATION_PERIOD_OPTIONS = [
  { value: 'all', label: 'TODOS LOS PERÍODOS' },
  { value: 'monthly', label: 'LIQUIDACIÓN MENSUAL' },
  { value: 'quarterly', label: 'LIQUIDACIÓN TRIMESTRAL' },
  { value: 'semiannually', label: 'LIQUIDACIÓN SEMESTRAL' },
  { value: 'annually', label: 'LIQUIDACIÓN ANUAL' },
];

export const AUTHOR_STATUS_OPTIONS = [
  { value: 'all', label: 'TODOS LOS ESTADOS' },
  { value: 'active', label: 'ACTIVO' },
  { value: 'inactive', label: 'INACTIVO' },
];

export const LIQUIDATION_PERIOD_LABELS: Record<string, string> = {
  monthly: 'Mensual',
  quarterly: 'Trimestral',
  semiannually: 'Semestral',
  annually: 'Anual',
};
